"use client";
import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { useTheme as f, Paper as x, Group as s, Icon as y, Heading as S, Paragraph as c, Divider as b, Accordion as g, Html as H, sharedHandler as N } from "@ingeniorforeningen/figurine-core";
import { forwardRef as v } from "react";
import { S as i } from "../../../../Schema.module-DGiUhHO2.js";
const n = v(
  (d, m) => {
    const { header: t, subHeader: l, tableData: r, variant: p } = d, h = f(), u = {
      "--passed-no-of-titles": r?.titles?.length
    };
    return /* @__PURE__ */ o(x, { p: "xl", ref: m, children: [
      /* @__PURE__ */ o(s, { align: "center", wrap: "nowrap", ml: "xs", mb: "md", children: [
        t.icon && /* @__PURE__ */ e(y, { name: t.icon, color: "dark" }),
        /* @__PURE__ */ o(s, { spacing: 0, className: i.optionalHeader, children: [
          /* @__PURE__ */ e(S, { type: "h2", text: t.title }),
          l && /* @__PURE__ */ e(c, { text: l, className: i.optionalSubHeader, condensed: !0 })
        ] })
      ] }),
      /* @__PURE__ */ e(b, { color: h.other?.colorTokens.dividers.light }),
      /* @__PURE__ */ e(
        g,
        {
          chevronPosition: "left",
          items: r.data.map((a) => ({
            value: a.title,
            label: /* @__PURE__ */ e(c, { text: a.title, condensed: !0 }, a.title),
            content: a.accordionData && /* @__PURE__ */ e(H, { html: a.accordionData }),
            icon: a.icon
          })),
          className: i.accordion,
          style: u,
          mod: { variant: p }
        }
      )
    ] });
  }
);
n.displayName = "SchemaOptional";
const D = N(n);
D.displayName = n.displayName;
export {
  n as _SchemaOptional,
  D as default
};
